import React, { useEffect, useState } from "react";
import Axios from "axios";
import { useNavigate, Link } from "react-router-dom";
import { profileUser } from "../api/service";
import Navbar from "../components/Navbar";
import {BiLike} from "react-icons/bi";
import {MdOutlineCategory}  from "react-icons/md";


const Trending = () => {
  let token = localStorage.getItem("token");
  const navigate = useNavigate();
  const profileInit = () => {
    profileUser(token).then((req, res) => {
      console.log(req.data);
      if (req.data.status !== "failed") {
        console.log(req.data);
      } else {
        navigate("/home");
      }
    });
  };


  const formatDateTime = (dateTimeString) => {
    const options = { year: "numeric", month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" };
    return new Date(dateTimeString).toLocaleDateString(undefined, options);
  };

  const [posts, setPosts] = useState([]);

  useEffect(() => {
    Axios.get(process.env.REACT_APP_API_BASE_URL + "/api/posts/", {
      headers: {
        authorization: token,
      },
    })
      .then((res) => {
        console.log(res.data);
        setPosts(res.data);
      })
      .catch((err) => console.log(err));
    profileInit();
  }, []);

  return (
<div>
  <Navbar />
  <div className="flex flex-wrap justify-center text-center pt-20 bg-[#0D1117]">
    <div className="w-full lg:w-8/12 px-4">
      <h1 className="text-gray-300 text-4xl font-bold mb-8">
        Trending Posts
      </h1>

      <p className="text-gray-400 text-lg font-light">
        Checkout the Trending Posts on Bombay Ballot and stay updated with the latest news.
      </p>
    </div>
  </div>
  <div className="md:flex md:flex-row flex-wrap p-5 bg-[#0D1117]">
    {posts
      .slice()
      .sort((a, b) => b.likes.length - a.likes.length)
      .slice(0, 5)
      .map((post) => (
        <div
          key={post._id}
          className="flex-shrink-0 w-full  bg-[#14171D] rounded-lg shadow-slate-800 shadow-md p-4 cursor-pointer 
          hover:shadow-sm transition duration-300 mb-4 md:mb-0 md:mr-4"
        >
        <div>
        
        <div class="bg-[#0D1117] border-[#161b22] border-2 rounded-lg shadow-2xl md:flex">
        <img
            alt="Bombay Ballot"
            src={post.image}
            className="self-center inline object-cover w-full h-full rounded-t-lg md:w-48 md:h-48 md:rounded-none md:rounded-l-lg"
          />
          <div class="p-6 text-center">
            <h2 class="font-bold text-xl md:text-3xl mb-2 text-white">
              {post.title}
            </h2>
            <p class="text-gray-400 w-fit line-clamp-3">
            {post.description}
              
            </p>
            <button
              className=" shadow-none w-40 text-[#d7dfe7] bg-[#1f7e30] font-bold py-2 px-4 hover:bg-[#2ea043] rounded-md h-10  my-4"
              type="submit"
              onClick={() => navigate("/posts/" + post._id)}
            >
              <div style={{ display: "flex", justifyContent: "center" }}>
                Read More
              </div>
            </button>
          </div>
        </div>
        </div>
        </div>
      ))}
  </div>
</div>


  );
};

export default Trending;
